<template>
  <span v-if="available">
    <span class="time">{{ timeStr }}</span>
    {{ tzName }}
  </span>
</template>

<script>
  export default {
    name: 'clock',
    data() {
      return {
        loading: false,
        tzName: null,
        offsetMs: null,
        timeStr: null,
      };
    },
    computed: {
      available() {
        return this.tzName !== null && this.timeStr !== null;
      },
    },
    mounted() {
      bus.$on('clock.reload', () => {
        this.loadData();
      });

      this.loadData();

      window.setInterval(() => {
        return this.updateTimeStr();
      }, 1000);
    },
    destroyed() {
      bus.$off('clock.reload');
    },
    methods: {
      loadData() {
        this.loading = true;

        axios.get('/timezone/current', { _: (new Date()).getTime()})
        .then(response => {
          this.loading = false;
          let match = response.data.time.match(
              /^([0-9]{4})\-([0-9]{2})\-([0-9]{2})\ ([0-9]{2})\:([0-9]{2})\:([0-9]{2})$/
          );
          if (null !== match) {
            let srvDate = new Date(
              parseInt(match[1]),     // Y
              parseInt(match[2]) - 1, // m
              parseInt(match[3]),     // d
              parseInt(match[4]),     // H
              parseInt(match[5]),     // i
              parseInt(match[6]),     // s
            );

            this.tzName = response.data.name
              .split('/').join(' / ')
              .split('_').join(' ');

            this.offsetMs = srvDate.getTime() - (new Date()).getTime();
          }
        })
        .catch(error => {
          // console.error(error);
        });
      },
      updateTimeStr() {
        if (null == this.offsetMs) return;
        let date = new Date((new Date()).getTime() + this.offsetMs);
        this.timeStr = [
          (date.getHours() < 10 ? '0' : '') + date.getHours(),
          (date.getMinutes() < 10 ? '0' : '') + date.getMinutes(),
          (date.getSeconds() < 10 ? '0' : '') + date.getSeconds(),
        ].join(':');
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Clock.vue